export const errorTypesMap = {
  EMAIL_ALREADY_TAKEN: 'EmailAlreadyTaken',
};

export interface ErrorResponseData {
  status: string;
  type: string;
  error: { type: string };
}
